import React, { useEffect, useState } from 'react'
import styles from './style.module.scss'
import { createPortal } from 'react-dom'

type SideNavProps = {
  isOpen: boolean
  onClose: () => void
  children?: React.ReactNode
}

const SideNav: React.FC<SideNavProps> = ({ isOpen, onClose, children }) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY

      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = `-${scrollY}px`
    } else {
      const scrollY = document.body.style.top
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''

      window.scrollTo(0, parseInt(scrollY || '0') * -1)
    }

    return () => {
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
    }
  }, [isOpen])

  const content = (
    <>
      <div className={`${styles.overlay} ${isOpen ? styles.visible : ''}`} onClick={onClose} />
      <nav className={`${styles.sideNav} ${isOpen ? styles.open : ''}`}>{children}</nav>
    </>
  )

  return <>{isClient ? createPortal(content, document.body) : null}</>
}

export default SideNav
